class FrontEcommerceChangeProductSwatches {
  constructor() {
    this.xhr = null;
    this.cache = new Map(); // Client-side cache for variation responses
    this.cacheTimeout = 5 * 60 * 1000; // 5 minutes cache

    this.handleEvents();
  }

  handleEvents() {
    let _self = this;
    let $body = $("body");

    $body.on("click", ".productDetail__section--attributes .productDetail__visualSwatch label, .productDetail__section--attributes .productDetail__text-swatch label", (e) => {
      e.preventDefault();

      let $this = $(e.currentTarget);
      let $radio = $this.find("input[type=radio]");

      if ($radio.is(":checked")) {
        return;
      }

      $radio.prop("checked", true);

      if ($this.closest(".productDetail__visualSwatch").find("input[type=radio]:checked").length < 1) {
        $radio.prop("checked", true);
      }

      $radio.trigger("change");
    });

    $body
      .off("change", ".productDetail__section--attributes input, .productDetail__section--attributes select")
      .on("change", ".productDetail__section--attributes input, .productDetail__section--attributes select", (event) => {
        const $parent = $(event.currentTarget).closest(".productDetail__section--attributes");

        _self.getProductVariation($parent);
      });

    if ($(".productDetail__section--attributes").length) {
      window.addEventListener(
        "popstate",
        function (e) {
          if (e.state?.product_attributes_id) {
            let $el = $("#" + e.state.product_attributes_id);

            if (window.onChangeSwatchesSuccess && typeof window.onChangeSwatchesSuccess === "function") {
              window.onChangeSwatchesSuccess(e.state.data, $el);
            }

            if (e.state.slugAttributes) {
              _self.updateSelectingAttributes(e.state.slugAttributes, $el);
            }
          } else {
            $(".productDetail__section--attributes").each(function (i, el) {
              let params = _self.parseParamsSearch();
              let attributes = [];
              let slugAttributes = {};
              let $el = $(el);

              if (params && Object.keys(params).length) {
                $.each(params, function (key, slug) {
                  let $parent = $el.find('.productDetail__section[data-slug="' + key + '"]');
                  if ($parent.length) {
                    let value;
                    if ($parent.data("type") === "dropdown") {
                      value = $parent.find('option[data-slug="' + slug + '"]').val();
                    } else {
                      value = $parent.find('input[data-slug="' + slug + '"]').val();
                    }

                    if (value) {
                      attributes.push(value);
                      slugAttributes[key] = value;
                    }
                  }
                });
              }

              _self.callAjax(attributes, $el, slugAttributes, false);
            });
          }
        },
        false,
      );
    }
  }

  getProductVariation($productAttributes) {
    let _self = this;
    let attributes = [];
    let slugAttributes = {};
    /**
     * Break current request
     */
    if (_self.xhr) {
      _self.xhr.abort();

      _self.xhr = null;
    }

    /**
     * Get attributes
     */
    let $attributeSwatches = $productAttributes.find(".productDetail__section");
    let referenceProduct = null;
    $attributeSwatches.each((index, el) => {
      let $current = $(el);

      let $input;
      if ($current.data("type") === "dropdown") {
        $input = $current.find("select option:selected");
      } else {
        $input = $current.find("input[type=radio]:checked");
      }

      let slug = $input.data("slug");
      let value = $input.val();

      if (value) {
        let setSlug = $current.find(".productDetail__attribute-swatch").data("slug");
        slugAttributes[setSlug] = slug;
        attributes.push(value);

        referenceProduct = $input.data("reference-product");
      }
    });

    _self.callAjax(attributes, $productAttributes, slugAttributes, true, referenceProduct);
  }

  callAjax = function (attributes, $productAttributes, slugAttributes, updateUrl = true, referenceProduct = null) {
    let _self = this;
    let formData = {
      attributes,
      _: +new Date(),
    };

    if (referenceProduct) {
      formData.reference_product = referenceProduct;
    }

    let id = $productAttributes.prop("id");

    // Create cache key from attributes and language
    const locale = document.documentElement.lang || "en";
    const cacheKey = JSON.stringify(attributes.sort()) + (referenceProduct || "") + "_v1_" + locale;

    // Check cache first
    const cached = _self.getFromCache(cacheKey);

    if (cached) {
      // Use cached response
      _self.handleResponse(cached, $productAttributes, slugAttributes, id, updateUrl);
      return;
    }

    _self.xhr = $.ajax({
      url: $productAttributes.data("target"),
      type: "GET",
      data: formData,
      beforeSend: () => {
        if (window.onBeforeChangeSwatches && typeof window.onBeforeChangeSwatches === "function") {
          window.onBeforeChangeSwatches(attributes, $productAttributes);
        }
      },
      success: (res) => {
        // Store in cache
        _self.setCache(cacheKey, res);

        // Handle response
        _self.handleResponse(res, $productAttributes, slugAttributes, id, updateUrl);
      },
      complete: (res) => {
        if (window.onChangeSwatchesComplete && typeof window.onChangeSwatchesComplete === "function") {
          window.onChangeSwatchesComplete(res, $productAttributes);
        }
      },
      error: (res) => {
        if (window.onChangeSwatchesError && typeof window.onChangeSwatchesError === "function") {
          window.onChangeSwatchesError(res, $productAttributes);
        }
      },
    });
  };

  updateSelectingAttributes = function (slugAttributes, $el) {
    $.each(slugAttributes, function (key, slug) {
      let $parent = $el.find('.productDetail__section[data-slug="' + key + '"]');

      if ($parent.length) {
        if ($parent.data("type") === "dropdown") {
          let selected = $parent.find('select option[data-slug="' + slug + '"]').val();
          $parent.find("select").val(selected);
        } else {
          $parent.find("input:checked").prop("checked", false);
          $parent.find("input[data-slug=" + slug + "]").prop("checked", true);
        }
      }
    });
  };

  parseParamsSearch = function (query, includeArray = false) {
    let pairs = query || window.location.search.substring(1);
    let re = /([^&=]+)=?([^&]*)/g;
    let decodeRE = /\+/g; // Regex for replacing addition symbol with a space
    let decode = function (str) {
      return decodeURIComponent(str.replace(decodeRE, " "));
    };
    let params = {},
      e;
    while ((e = re.exec(pairs))) {
      let k = decode(e[1]),
        v = decode(e[2]);
      if (k.substring(k.length - 2) === "[]") {
        if (includeArray) {
          k = k.substring(0, k.length - 2);
        }
        (params[k] || (params[k] = [])).push(v);
      } else params[k] = v;
    }
    return params;
  };

  handleResponse = function (res, $productAttributes, slugAttributes, id, updateUrl) {
    let _self = this;

    if (window.onChangeSwatchesSuccess && typeof window.onChangeSwatchesSuccess === "function") {
      window.onChangeSwatchesSuccess(res, $productAttributes);
    }

    const { data, message } = res;

    if (data && !data.error_message) {
      if (data.selected_attributes) {
        slugAttributes = {};
        $.each(data.selected_attributes, (index, item) => {
          slugAttributes[item.set_slug] = item.slug;
        });
      }

      const url = new URL(window.location);

      if (id) {
        _self.updateSelectingAttributes(slugAttributes, $("#" + id));
      }

      $.each(slugAttributes, (name, value) => {
        url.searchParams.set(name, value);
      });

      if (updateUrl && url != window.location.href) {
        window.history.pushState({ formData: { attributes: res.data.attributes }, data: res, product_attributes_id: id, slugAttributes }, message, url);
      } else {
        window.history.replaceState({ formData: { attributes: res.data.attributes }, data: res, product_attributes_id: id, slugAttributes }, message, url);
      }
    }
  };

  getFromCache(key) {
    const item = this.cache.get(key);
    if (!item) return null;

    // Check if cache is expired
    if (Date.now() - item.timestamp > this.cacheTimeout) {
      this.cache.delete(key);
      return null;
    }

    return item.data;
  }

  setCache(key, data) {
    this.cache.set(key, {
      data: data,
      timestamp: Date.now(),
    });

    // Limit cache size to prevent memory issues
    if (this.cache.size > 100) {
      // Remove oldest entries
      const firstKey = this.cache.keys().next().value;
      this.cache.delete(firstKey);
    }
  }
}

$(() => {
  const frontEcommerceSwatchInstance = new FrontEcommerceChangeProductSwatches();
  // Check initial selection on page load
  $(".productDetail__section--attributes").each(function () {
    const $container = $(this);
    const hasCheckedVariation = $container.find("input[type=radio]:checked:not(:disabled)").length > 0;

    // If no valid variation is selected, select the first available one
    if (!hasCheckedVariation) {
      $container.find(".productDetail__section").each(function () {
        const $wrapper = $(this);
        const $firstAvailable = $wrapper.find("input[type=radio]:not(:disabled)").first();

        if ($firstAvailable.length) {
          $firstAvailable.prop("checked", true);
        }
      });

      // Trigger change to update product info
      frontEcommerceSwatchInstance.getProductVariation($container);
    }
  });
});
